import { render, staticRenderFns } from "./edit-partner-rrp-pricing.vue?vue&type=template&id=d8bda1d6&scoped=true&"
import script from "./edit-partner-rrp-pricing.vue?vue&type=script&lang=js&"
export * from "./edit-partner-rrp-pricing.vue?vue&type=script&lang=js&"
import style0 from "./edit-partner-rrp-pricing.vue?vue&type=style&index=0&id=d8bda1d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bda1d6",
  null
  
)

export default component.exports